import React from 'react'
import { UserProviderUserDto } from '~/modules/Auth/Infrastructure/Dtos/UserProviderUserDto'
import { ProfileDto } from '~/modules/Profile/ProfileDto'
import { emptySocials } from '~/modules/Profile/SocialsDto'
import { Banner } from './Banner'
import { Biography } from './Biography'
import { Socials } from './Socials'
import styles from './index.module.scss'

interface UserHeaderProps {
  title: string
  url: string
  user: UserProviderUserDto
  profile: ProfileDto
}

export const UserHeader: React.FC<UserHeaderProps> = ({ title, url, user, profile }) => {
  const hasBiography = Boolean(profile.bio)
  const hasSocials = !emptySocials(profile.socials)

  return (
    <div className={ styles.userHeader__container }>
      <div className={ styles.userHeader__banner }>
        <Banner
          title={ title }
          url={ url }
          user={ user }
        />
      </div>

      { hasBiography && (
        <div className={ styles.userHeader__bio }>
          <Biography profile={ profile }/>
        </div>
      ) }

      { hasSocials && (
        <div className={ styles.userHeader__socials }>
          <Socials profile={ profile }/>
        </div>
      ) }
    </div>
  )
}
